goog.provide("shadow.js.shim.module$ttag");
goog.provide("module$shadow_js_shim_module$ttag");
shadow.js.shim.module$ttag = shadow.js.nativeProvides["ttag"] = require("ttag");
module$shadow_js_shim_module$ttag.default = shadow.js.shim.module$ttag;
